<template>
    <div>
        <h6 class="heading-small text-muted mb-3">ตรวจสอบข่้อมูลกรอกในระบบ</h6>
        <div class="row mb-2">
            <div class="col-lg-12">
                <b-form-group>
                    <b-form-radio-group
                        v-model="verify.status"
                        :options="listApproveOnline"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col-lg-12" v-if="verify.status == 'REJECT'">
                <label>คำอธิบายเพิ่มเติม (ไม่บังคับ)</label>
                <textarea
                    rows="3"
                    class="form-control"
                    placeholder="หมายเหตุ"
                    v-model="verify.remark"
                ></textarea>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        verify: Object
    },
    data() {
        return {
            listApproveOnline: [
                { text: 'อนุมัติ', value: 'APPROVED' },
                { text: 'ไม่อนุมัติ', value: 'REJECT' },
            ],
        }
    },
}
</script>